var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1965_11394",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1965_11394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8545 16.7083L11.042 11.9167C10.6253 12.2639 10.1461 12.5347 9.60445 12.7292C9.06278 12.9236 8.50723 13.0208 7.93778 13.0208C6.50723 13.0208 5.2989 12.5278 4.31278 11.5417C3.32667 10.5556 2.83362 9.34722 2.83362 7.91667C2.83362 6.5 3.32667 5.295 4.31278 4.30167C5.2989 3.30889 6.50723 2.8125 7.93778 2.8125C9.35445 2.8125 10.5558 3.30556 11.542 4.29167C12.5281 5.27778 13.0211 6.48611 13.0211 7.91667C13.0211 8.51389 12.9239 9.08333 12.7295 9.625C12.535 10.1667 12.2711 10.6389 11.9378 11.0417L16.7503 15.8542C16.8614 15.9653 16.917 16.1042 16.917 16.2708C16.917 16.4375 16.8545 16.5833 16.7295 16.7083C16.6045 16.8333 16.4553 16.8958 16.282 16.8958C16.1081 16.8958 15.9656 16.8333 15.8545 16.7083ZM7.93778 11.7708C9.00723 11.7708 9.91362 11.3958 10.657 10.6458C11.3997 9.89583 11.7711 8.98611 11.7711 7.91667C11.7711 6.84722 11.3997 5.9375 10.657 5.1875C9.91362 4.4375 9.00723 4.0625 7.93778 4.0625C6.85445 4.0625 5.9414 4.4375 5.19862 5.1875C4.45528 5.9375 4.08362 6.84722 4.08362 7.91667C4.08362 8.98611 4.45528 9.89583 5.19862 10.6458C5.9414 11.3958 6.85445 11.7708 7.93778 11.7708Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f9d99b2c9c18d9561468cc95b0bad8d9.svg";
export { ForwardRef as ReactComponent };